
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entdecken/[[...path]]",
      function () {
        return require("private-next-pages/entdecken/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entdecken/[[...path]]"])
      });
    }
  